import React from "react";
import ShowDatePicker from "./ShowDatePicker";
import TimeOfPerformance from "./TimeOfPerformance";
import { ShowDates } from "./models";
import { areShowDatesValid } from "./utils";

interface ShowDateAndTimePickerProps {
  timePickerPlaceholder?: string
  showDates: ShowDates
  onChange: (showDates: ShowDates, hasErrors: boolean, submit: boolean) => void
  compact: boolean
}

export const ShowDateAndTimePicker = (props: ShowDateAndTimePickerProps) => {
  return <div>
    <ShowDatePicker
      compact={props.compact}
      validatorKey="showDates"
      dates={props.showDates}
      onDatesChanged={(newDates, hasErrors) => props.onChange(newDates, hasErrors, false)}
    />

    {props.showDates.mode === "allDay" && <TimeOfPerformance
      placeholder={props.timePickerPlaceholder}
      showDates={props.showDates}
      onTimeOfPerformanceChanged={(time, submit) => {
        const newShowDates = { ...props.showDates, timeOfPerformance: time };
        const hasErrors = !areShowDatesValid(newShowDates);
        props.onChange(newShowDates, hasErrors, submit);
      }}
    />}
  </div>
}